import { Button, ButtonType } from "@/components/common/button";
import { QuizQuestionProps } from "@/pages/quiz/context/types";
import { doctorPrescribeBanner, doctorPrescribeBannerV2 } from "@/assets/images";
import { useIsABTest } from "@/hooks/useIsABTest";

const DoctorPrescribeBanner = ({
  setQuestionAnswer,
}: QuizQuestionProps<boolean>) => {
  const { isABTest_6_Header } = useIsABTest();

  return (
    <div className="flex flex-col justify-center">
      {
        !isABTest_6_Header && <p className="section-title">
          The medications that our licensed weight loss specialists prescribe are
          recommended by Harvard, Mayo Clinic, WebMD & the National Institutes of
          Health.
        </p>
      }

      <img src={isABTest_6_Header ? doctorPrescribeBannerV2 : doctorPrescribeBanner} alt="SkinnyRx benefits" />

      <Button onClick={() => setQuestionAnswer(true)} type={ButtonType.NEXT} />
    </div>
  );
};

export { DoctorPrescribeBanner };
